import { Box, Grid, Typography } from "@mui/material";
import PropTypes from "prop-types";

import ProfilePicture from "./ProfilePicture";
import { candidateRegion, candidateType, employmentDuration, shiftType, urgencyLevel } from "../../utilities/dropdowns";

const CompanyViewer = ({ data, zoomOut }) => (
  <Box>
    <Box sx={{ boxShadow: "0px 0px 40px -24px rgba(0,0,0,0.75)", borderRadius: "10px", padding: "20px 20px", wordWrap: "break-word" }}>
      <Grid container className="grid-container" sx={{ marginBottom: "20px" }}>
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <Box padding="0 10%">
            <ProfilePicture profilePicture={data.companyLogo} zoomOut={zoomOut} />
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={9} lg={9}>
          <Box sx={{ textAlign: "left" }}>
            <Typography variant="h4" fontSize={zoomOut ? "13px" : "16px"} sx={{ color: "#C02026" }}>
              {data.name}
            </Typography>
          </Box>
          <hr style={{ border: "2px solid rgb(0 0 0 / 43%)" }} />
          <Box sx={{ textAlign: "left" }}>
            <Typography fontSize={zoomOut ? "11px" : "14px"}>Registered Name: {data?.registeredName}</Typography>
            <Typography fontSize={zoomOut ? "11px" : "14px"}>Phone: {data.phone}</Typography>
            <Typography fontSize={zoomOut ? "11px" : "14px"}>
              Address:{" "}
              {data?.address &&
                data.address?.country &&
                data.address?.city &&
                data.address?.zipCode &&
                data.address?.address &&
                `${data?.address?.country}, 
                                  ${data?.address?.city} ${data?.address?.zipCode}, 
                                  ${data?.address?.address}`}
            </Typography>
            <Typography fontSize={zoomOut ? "11px" : "14px"}>
              Additional address:{" "}
              {data?.additionalAddress &&
                data.additionalAddress?.country &&
                data.additionalAddress?.city &&
                data.additionalAddress?.zipCode &&
                data.additionalAddress?.address &&
                `${data?.additionalAddress?.country}, 
                                  ${data?.additionalAddress?.city} ${data?.additionalAddress?.zipCode}, 
                                  ${data?.additionalAddress?.address}`}
            </Typography>
            <Typography fontSize={zoomOut ? "11px" : "14px"}>Registration Number: {data.registrationNumber}</Typography>
            <Typography fontSize={zoomOut ? "11px" : "14px"}>Tax Number: {data.taxNumber}</Typography>
          </Box>
          <Box sx={{ textAlign: "left", marginTop: "5px" }}>
            <Typography fontSize={zoomOut ? "11px" : "14px"} fontWeight="500">
              Hiring Requirements
            </Typography>
            <Box p="5px">
              <Typography fontSize={zoomOut ? "11px" : "14px"}>
                Candidate Type:{" "}
                {data.candidateType
                  ? data.candidateType
                      .map((val) => {
                        const match = candidateType.find((c) => c.value === val);
                        return match ? match.label : val;
                      })
                      .join(", ")
                  : ""}
              </Typography>
              <Typography fontSize={zoomOut ? "11px" : "14px"}>Candidate Region: {data.candidateRegion ? candidateRegion.find((c) => c.value === data.candidateRegion)?.label : ""}</Typography>
              <Typography fontSize={zoomOut ? "11px" : "14px"}>Country: {data.country}</Typography>
              <Typography fontSize={zoomOut ? "11px" : "14px"}>Industry: {data.industry}</Typography>
              <Typography fontSize={zoomOut ? "11px" : "14px"}>
                Job Type:{" "}
                {data.employmentTypes
                  ? data.employmentTypes
                      .map((val) => {
                        const match = candidateType.find((c) => c.value === val);
                        return match ? match.label : val;
                      })
                      .join(", ")
                  : ""}
              </Typography>
              <Typography fontSize={zoomOut ? "11px" : "14px"}>Number of candidates needed: {data.numberOfCandidates}</Typography>
              <Typography fontSize={zoomOut ? "11px" : "14px"}>Urgency level: {data.urgencyLevel ? urgencyLevel.find((c) => c.value === data.urgencyLevel)?.label : ""}</Typography>
              <Typography fontSize={zoomOut ? "11px" : "14px"}>
                Employment duration: {data.employmentDuration ? employmentDuration.find((c) => c.value === data.employmentDuration)?.label : ""}
              </Typography>
              <Typography fontSize={zoomOut ? "11px" : "14px"}>Working hours per week: {data.workingHours}</Typography>
              <Typography fontSize={zoomOut ? "11px" : "14px"}>Shift Type: {data.shiftType ? shiftType.find((c) => c.value === data.shiftType)?.label : ""}</Typography>
              <Typography fontSize={zoomOut ? "11px" : "14px"}>Accommodation provided: {data.accommodationProvided ? "Yes" : "No"}</Typography>
              <Typography fontSize={zoomOut ? "11px" : "14px"}>Transport provided: {data.transportProvided ? "Yes" : "No"}</Typography>
              <Typography fontSize={zoomOut ? "11px" : "14px"}>Salary range: {data.salaryRange}</Typography>
            </Box>
          </Box>
          {/* <Box sx={{ textAlign: "left", marginTop: "5px" }}>
            <Typography fontSize={zoomOut ? "11px" : "14px"} fontWeight="500">
              Contact Person
            </Typography>
            <Box p="5px">
              <Typography fontSize={zoomOut ? "11px" : "14px"}>Email: {data.contactPersonEmail}</Typography>
              <Typography fontSize={zoomOut ? "11px" : "14px"}>Name: {data.contactPersonName}</Typography>
              <Typography fontSize={zoomOut ? "11px" : "14px"}>Surname: {data.contactPersonSurname}</Typography>
              <Typography fontSize={zoomOut ? "11px" : "14px"}>Phone: {data.contactPersonPhone}</Typography>
            </Box>
          </Box> */}
          {data.contacts && data.contacts.length > 0 && (
            <Box sx={{ textAlign: "left", marginTop: "5px" }}>
              <Typography fontSize={zoomOut ? "11px" : "14px"} fontWeight="500">
                Contact Persons List
              </Typography>
              {data.contacts.map((user, index) => (
                <Box key={user.id} p="5px" sx={{ borderBottom: data.contacts.length - 1 !== index ? "1px solid #ccc" : "none" }}>
                  <Typography fontSize={zoomOut ? "11px" : "14px"}>First Name: {user.firstName}</Typography>
                  <Typography fontSize={zoomOut ? "11px" : "14px"}>Last Name: {user.lastName}</Typography>
                  <Typography fontSize={zoomOut ? "11px" : "14px"}>Email: {user.email}</Typography>
                  <Typography fontSize={zoomOut ? "11px" : "14px"}>Phone: {user.phone}</Typography>
                </Box>
              ))}
            </Box>
          )}
          <hr />
        </Grid>
      </Grid>
    </Box>
  </Box>
);

CompanyViewer.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    phone: PropTypes.string,
    registeredName: PropTypes.string,
    companyLogo: PropTypes.shape({
      fileUrl: PropTypes.string,
    }),
    registrationNumber: PropTypes.string,
    taxNumber: PropTypes.string,
    candidateType: PropTypes.arrayOf(PropTypes.string),
    employmentTypes: PropTypes.arrayOf(PropTypes.string),
    numberOfCandidates: PropTypes.string,
    urgencyLevel: PropTypes.string,
    employmentDuration: PropTypes.string,
    workingHours: PropTypes.string,
    shiftType: PropTypes.string,
    accommodationProvided: PropTypes.string,
    transportProvided: PropTypes.string,
    salaryRange: PropTypes.string,
    candidateRegion: PropTypes.string,
    country: PropTypes.string,
    industry: PropTypes.string,
    address: PropTypes.shape({
      country: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      zipCode: PropTypes.string.isRequired,
      address: PropTypes.string.isRequired,
    }),
    additionalAddress: PropTypes.shape({
      country: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      zipCode: PropTypes.string.isRequired,
      address: PropTypes.string.isRequired,
    }),
    contactPersonName: PropTypes.string,
    contactPersonSurname: PropTypes.string,
    contactPersonPhone: PropTypes.string,
    contactPersonEmail: PropTypes.string,
    contacts: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        email: PropTypes.string,
        phone: PropTypes.string,
      }),
    ),
  }),
  zoomOut: PropTypes.bool,
};

CompanyViewer.defaultProps = {
  data: {
    name: "ACME Company",
    registeredName: "",
    taxNumber: "",
    phone: "",
    industry: "",
    contactPersonName: "",
    contactPersonSurname: "",
    contactPersonPhone: "",
  },
  zoomOut: false,
};

export default CompanyViewer;
